import { create } from "zustand";

const useCurrencyStore = create((set) => ({
  currencySymbol: "",
  setCurrencySymbol: (symbol) => set({ currencySymbol: symbol }),
  clearCurrencySymbol: () => set({ currencySymbol: "" }),
}));

export default useCurrencyStore;
